import { render, staticRenderFns } from "./BreakingUpdateModal.vue?vue&type=template&id=8068fbea&scoped=true&"
import script from "./BreakingUpdateModal.vue?vue&type=script&lang=js&"
export * from "./BreakingUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./BreakingUpdateModal.vue?vue&type=style&index=0&id=8068fbea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8068fbea",
  null
  
)

export default component.exports